import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, money } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Field, AccountSelect } from "@/components/FormBits";

export default function ZelleForm({ accounts, onDone }) {
  const [from, setFrom] = useState("");
  const [recipient, setRecipient] = useState("");
  const [amount, setAmount] = useState("");
  const [memo, setMemo] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!from) return toast.error("Choose an account");
    setBusy(true);
    try {
      const r = await api.post("/zelle", { from_account_id: from, recipient, amount: parseFloat(amount), memo });
      toast.success(`Sent ${money(parseFloat(amount))} to ${r.data.recipient}`);
      setAmount(""); setRecipient(""); setMemo(""); onDone();
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };

  return (
    <form onSubmit={submit} className="tile max-w-2xl" data-testid="zelle-form">
      <div className="p-7 grid gap-5">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full bg-[#6d1ed4] text-white grid place-items-center font-display font-bold">Z</div>
          <div><div className="font-display font-semibold text-[var(--navy)]">Send money with Zelle®</div><div className="text-xs text-slate-500">Send to any enrolled Maderian member by username or email.</div></div>
        </div>
        <Field label="From"><AccountSelect accounts={accounts.filter((a) => a.type !== "investment")} value={from} onChange={setFrom} testid="zelle-from-select" /></Field>
        <Field label="Recipient username or email"><Input value={recipient} onChange={(e) => setRecipient(e.target.value)} required data-testid="zelle-recipient-input" /></Field>
        <Field label="Amount"><Input type="number" step="0.01" min="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} required data-testid="zelle-amount-input" /></Field>
        <Field label="Memo (optional)"><Input value={memo} onChange={(e) => setMemo(e.target.value)} data-testid="zelle-memo-input" /></Field>
        <Button disabled={busy} className="rounded-full bg-[var(--blue)] hover:bg-[var(--navy)] h-11" data-testid="zelle-submit-button">{busy ? "Sending..." : "Send"}</Button>
      </div>
    </form>
  );
}
